import ChangeEvent = JQuery.ChangeEvent;

export default class FileField {
    private readonly $holder: JQuery;
    private readonly $input: JQuery;
    private readonly $valuesHolder: JQuery;

    constructor($holder: JQuery) {
        this.$holder = $holder;
        this.$input = $holder.find('input[type="file"]');
        this.$valuesHolder = this.$holder.find('.js-file-values');

        this.changeFileHandler = this.changeFileHandler.bind(this);
        this.clickDeleteHandler = this.clickDeleteHandler.bind(this);

        this.init();
    }

    /**
     * Инициализация
     * @private
     */
    private init(): void
    {
        this.initEvents();
    }

    /**
     * Инициализация событий
     * @private
     */
    private initEvents(): void
    {
        this.$holder.on('change', '.js-file-label input', this.changeFileHandler);
        this.$holder.on('click', '.js-file-delete', this.clickDeleteHandler);
    }

    /**
     * Обработать файл
     * @param data
     * @private
     */
    private processFile(data: FileList|null): void
    {
        if (!data || !data.length) {
            return;
        }

        this.clearValuesBlock();

        for (let i = 0, l = data.length; i < l; i++) {
            const file = data[i];

            this.createTemplateFile(file);
        }
    }

    /**
     * Сбросить поле
     */
    public reset(): void
    {
        this.clearValuesBlock();
        this.$input.val('');
    }

    /**
     * Очистить блок значений
     * @private
     */
    private clearValuesBlock(): void
    {
        this.$valuesHolder.html('');
    }

    /**
     * Создать шаблон файла
     * @param file
     * @private
     */
    private createTemplateFile(file: File): void
    {
        const $template = this.$holder.find('.js-file-template .js-file-view');
        const $cloneTemplate = $template.clone();

        $cloneTemplate.find('.js-file-view-name').text(file.name);

        this.$valuesHolder.append($cloneTemplate);
    }

    /**
     * Обработчик изменения файла
     * @param evt
     * @private
     */
    private changeFileHandler(evt: ChangeEvent): void
    {
        const target: HTMLInputElement = evt.target as HTMLInputElement;

        this.processFile(target.files);
    }

    /**
     * Обработчик клик по кнопке удалить
     * @private
     */
    private clickDeleteHandler(): void
    {
        this.reset();
    }
}
